// removed by extract-text-webpack-plugin
module.exports = {"root":"Toolbox__root___18Ris","title":"Toolbox__title___vgX1G","row":"Toolbox__row___T7f1q","colorPicker":"Toolbox__colorPicker___rBLM2","label":"Toolbox__label___2OanM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Toolbox/Toolbox.scss
// module id = 980
// module chunks = 0